import {
  TEntityOverride,
} from 'src/types'

const override: TEntityOverride = {
  titleField: 'url',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
}

export default override
